module.exports = __webpack_public_path__ + "static/media/Logo.d42981f5.png";